import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  InfoWindow,
} from "@react-google-maps/api";
import Rating from "@mui/material/Rating";
import PIN from "../assets/icons/pinhotel.png";
import { useSelector } from "react-redux";
const mapContainerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "6px",
};

const GoogleMapComp = ({
  markerData,
  onemarkerData,
  styles,
  zoom,
  setInfoMarkerData,
  noofDays,
  noofrooms,
  onCardClick,
  currency,
}) => {
  const [markers, setMarkers] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(zoom || 15);
  const { token } = useSelector((state) => state.auth);
  const APIKEY = process.env.REACT_APP_GOOGLE_API_KEY;
  const [center, setCenter] = useState({
    lat: 40.77506198319344,
    lng: -73.97868234389917,
  });
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCenter({ lat: latitude, lng: longitude });
        },
        (err) => {
          console.log(err.message);
        }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };
  useEffect(() => {
    setSelectedMarker(setInfoMarkerData);
    if (markerData && markerData.length > 0) {
      setMarkers(markerData);
      setCenter({
        lat: Number(markerData[0]?.geoCode?.lat),
        lng: Number(markerData[0]?.geoCode?.long),
      });
    } else if (onemarkerData) {
      setCenter({
        lat: Number(onemarkerData?.lat),
        lng: Number(onemarkerData?.long),
      });
      setMarkers([
        {
          lat: Number(onemarkerData?.lat),
          long: Number(onemarkerData?.long),
        },
      ]);
    } else {
      getLocation();
      setMarkers([]);
    }
  }, [markerData, onemarkerData, setInfoMarkerData]);
  const setHotelMarker = (mdata) => {
    setSelectedMarker(mdata);
  };
  return (
    <GoogleMap
      mapContainerStyle={{ ...mapContainerStyle, ...styles }}
      center={center}
      zoom={zoomLevel}
      onClick={() => setSelectedMarker(null)}
      options={{ fullscreenControl: false }}
    >
      {/* {markers.map((marker, index) => (
        <Marker
          key={index}
          position={{
            lat: Number(marker?.geoCode?.lat) || marker.lat,
            lng: Number(marker?.geoCode?.long) || marker.long,
          }}
          onClick={() => setSelectedMarker(marker)}
        />
      ))} */}
      {markers.map((marker, index) =>
        marker.type === "pin" ? (
          <Marker
            key={index}
            position={{
              lat: Number(marker.lat),
              lng: Number(marker.lng),
            }}
            onClick={() => {
              setSelectedMarker(marker);
            }}
          />
        ) : (
          <Marker
            key={index}
            position={{
              lat: Number(marker?.geoCode?.lat) || marker.lat,
              lng: Number(marker?.geoCode?.long) || marker.long,
            }}
            icon={{
              url: PIN, // Update with your custom marker URL
              scaledSize: new window.google.maps.Size(30, 30), // Adjust size as needed
            }}
            onClick={() => {
              setSelectedMarker(marker);
              onCardClick(index);
            }}
          />
        )
      )}
      {!onemarkerData &&
        selectedMarker &&
        (selectedMarker.type === "pin" ? (
          <InfoWindow
            position={{
              lat: selectedMarker.lat,
              lng: selectedMarker.lng,
            }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div>
              <h3>{selectedMarker?.name}</h3>
              <p>{selectedMarker?.address}</p>
              <div style={{ height: "15vh" }}>
                <img
                  src={selectedMarker.image}
                  alt="Pinned location"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                  loading="lazy"
                />
              </div>
              {/* {selectedMarker?.openingHours !== "" &&
              selectedMarker?.openingHours !== undefined && (
                <p>Start Time: {selectedMarker?.openingHours}</p>
              )} */}
              {/* {selectedMarker?.userRatings && (
              <p>User ratings:- {selectedMarker?.userRatings}</p>
            )} */}
              {selectedMarker?.ratings && (
                // <p> Ratings:- {selectedMarker?.ratings}</p>
                <Rating
                  name="read-only"
                  value={selectedMarker?.ratings}
                  readOnly
                />
              )}
            </div>
          </InfoWindow>
        ) : (
          <InfoWindow
            position={{
              lat: Number(selectedMarker?.geoCode?.lat),
              lng: Number(selectedMarker?.geoCode?.long),
            }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div className="p-0 m-0">
              <div style={{ height: "180px" }}>
                <img
                  src={selectedMarker?.heroImage}
                  alt={selectedMarker?.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                  loading="lazy"
                />
              </div>
              <h3>{selectedMarker?.name}</h3>
              <p>{selectedMarker?.starRating}-star hotel</p>
              <div style={{ textAlign: "end" }} className="px-3 pb-2">
                <p
                  className="fs-10 fw-700 "
                  style={{
                    color: "var(--light-grey)",
                    textDecoration: "line-through",
                    textDecorationColor: "var(--red-color)",
                  }}
                >
                  {selectedMarker.discount !== 0 &&
                    `$${selectedMarker?.rate?.totalRate.toFixed(2)}`}
                </p>
                {token ? (
                  selectedMarker?.rate?.discountPrice && (
                    <>
                      <p
                        className="fs-12 fw-700"
                        style={token ? {} : { filter: `blur(3px)` }}
                      >
                        {currency?.symbol || "$"}{" "}
                        {(
                          (selectedMarker?.rate?.discountPrice *
                            (currency?.value ?? 1)) /
                          noofDays
                        ).toFixed(2)}
                      </p>
                      <p
                        className="fs-8"
                        style={{ color: "var(--light-grey)" }}
                      >
                        {/* per {selectedMarker?.rate?.noOfDays} nights */}

                        {noofrooms === 1
                          ? "average nightly"
                          : "average per room"}
                      </p>
                      {/* <p className="fs-6" style={{ color: "var(--light-grey)" }}>
                              Total inclusive of taxes, fees & additional charges
                            </p> */}
                    </>
                  )
                ) : (
                  <p className="fs-10 fw-700">
                    <span style={{ color: "#e67e22" }}>Save up to 20%</span>
                  </p>
                )}
              </div>
            </div>
          </InfoWindow>
        ))}
    </GoogleMap>
  );
};

export default GoogleMapComp;
